export default __webpack_public_path__ + "static/media/close-image-popup.0a7e3562.svg";